// services/notificationService.js
import api from "./api.js";

// جلب كل الإشعارات
export const getNotifications = async () => {
  try {
    const response = await api.get("/notifications");
    return response.data?.notifications;
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to fetch notifications.";
    console.error("Get Notifications Failed:", errMsg);
    throw new Error(errMsg);
  }
};

// تعليم notification واحدة كـ read
export const markNotificationAsRead = async (notifId) => {
  try {
    const response = await api.patch(`/notifications/${notifId}/read`);
    return response.data;
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to mark notification as read.";
    console.error("Mark Notification Failed:", errMsg);
    throw new Error(errMsg);
  }
};

// تعليم كل الإشعارات كـ read
export const markAllNotificationsAsRead = async () => {
  try {
    const response = await api.patch("/notifications/read-all");
    return response.data;
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to mark all notifications as read.";
    console.error("Mark All Notifications Failed:", errMsg);
    throw new Error(errMsg);
  }
};

// مسح كل الإشعارات
export const clearNotifications = async () => {
  try {
    const response = await api.patch("/notifications/clear-notifications");
    return response.data;
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to clear notifications.";
    console.error("Clear Notifications Failed:", errMsg);
    throw new Error(errMsg);
  }
};
